type Handler = (folderId: string) => void;
const handlers: Set<Handler> = new Set();

export const folderBus = {
  emitFolderOpen: (folderId: string) => {
    handlers.forEach(h => h(folderId));
  },
  onFolderOpen: (handler: Handler) => {
    handlers.add(handler);
    return () => handlers.delete(handler);
  }
};
